import {
  Button,
  Grid,
  MenuItem,
  TextField,
  TextField as TextFieldMt,
} from '@mui/material'
import { isEqual } from 'lodash'
import { memo, useCallback, useState } from 'react'
import { metodoPrograma } from '../../../components/api'
import { useForm, Controller } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { z } from 'zod'
import PrimeTable from '../../../components/PrimeTable'
import ModalOpcoes from './ModalOpcoes'
import { setSuccess } from '../../../components/alerts'
import FileUploader from '../../../components/FileUploader'

const retornaLocalAtendimento = (u = []) => ({
  idQuestionario: u?.[0] || undefined,
  dsNome: u?.[1] || '',
  dsIntroducao: u?.[2] || '',
  dtExclusao: u?.[4] || '',
})

const createAgenda = z.object({
  idQuestionario: z.number().optional(),
  dsNome: z.string().min(3, {
    message: 'Nome inválido',
  }),
  dsIntroducao: z.string().nullable().optional(),
})

export const listaSituacao = [
  ['L', 'Texto Livre'],
  ['M', 'Mpultipla Escolha'],
  ['U', 'Escolha Única'],
  ['T', 'Coluna Texto Livre'],
  ['C', 'Coluna Múltipla'],
  ['O', 'Coluna Seleção Única'],
  ['I', 'Marcação na Imagem'],
]

export const STATUS_MAP = {
  L: {
    label: 'Texto Livre',
    color: '#1976d2',
    background: '#e3f2fd',
  },
  M: {
    label: 'Mpultipla Escolha',
    color: '#1976d2',
    background: '#e3f2fd',
  },
  U: {
    label: 'Escolha Única',
    color: '#1976d2',
    background: '#e3f2fd',
  },
  T: {
    label: 'Coluna Texto Livre',
    color: '#1976d2',
    background: '#e3f2fd',
  },
  C: {
    label: 'Coluna Múltipla',
    color: '#1976d2',
    background: '#e3f2fd',
  },
  O: {
    label: 'Coluna Seleção Única',
    color: '#1976d2',
    background: '#e3f2fd',
  },
  I: {
    label: 'Marcação na Imagem',
    color: '#1976d2',
    background: '#e3f2fd',
  },
}

export function StatusChip({ status }) {
  const info = STATUS_MAP[status]

  if (!info) return status

  return (
    <span
      style={{
        display: 'inline-block',
        padding: '4px 10px',
        borderRadius: '12px',
        fontSize: '12px',
        fontWeight: 600,
        width: '100%',
        color: info.color,
        backgroundColor: info.background,
        textAlign: 'center',
      }}
    >
      {info.label}
    </span>
  )
}

const Edicao = ({ dados, voltar }) => {
  const [refresh, setRefresh] = useState(0)
  const [perguntaSelecionada, setPerguntaSelecionada] = useState([])
  const [openModalDadosCadastrais, setOpenModalDadosCadastrais] =
    useState(false)
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: zodResolver(createAgenda),
    defaultValues: retornaLocalAtendimento(dados),
  })

  const handleClick = (linha) => {
    setPerguntaSelecionada(linha)
    setOpenModalDadosCadastrais(true)
  }

  const salva = async (values) => {
    const res = await metodoPrograma('salva', values)
    if (res.status) {
      setRefresh((prev) => prev + 1)
      voltar()
    }
  }

  const exclui = useCallback((dados) => {
    metodoPrograma('excluiPergunta', {
      idQuestionario: dados[0],
      idPergunta: dados[1],
    }).then((res) => {
      if (res.status) {
        setRefresh((prev) => prev + 1)
      }
    })
  }, [])

  const salvaPergunta = async (valuesTabela) => {
    const payload = {
      idQuestionario: dados[0],
      dsPergunta: valuesTabela.dsPergunta,
      tpPergunta: valuesTabela.tpPergunta,
      snObrigaResposta: valuesTabela.snObrigaResposta,
      snHabilitaJustificativa: valuesTabela.snHabilitaJustificativa,
    }

    const resp = await metodoPrograma('salvaPergunta', payload)

    if (resp.status) {
      setSuccess('Opção Cadastrada')
      setRefresh((v) => !v)
    }
  }

  const salvaDocumento = async (linha, v) => {
    const documento = v?.documento[0]

    const payload = {
      idDocumento: documento?.idDocumento,
      dsDocumento: documento?.fileName,
      idQuestionario: linha?.[0],
      idPergunta: linha?.[1],
    }

    await metodoPrograma('salvaDocumentoPerguntaPergunta', payload)

    setRefresh((v) => !v)
  }

  const editarPergunta = async (linha, close) => {
    const payload = {
      idQuestionario: linha?.[0],
      idPergunta: linha?.[1],
      dsPergunta: linha?.[2],
      tpPergunta: linha?.[3],
      snObrigaResposta: linha?.[7],
      snHabilitaJustificativa: linha?.[8],
    }
    const resp = await metodoPrograma('salvaPergunta', payload)

    if (resp.status) {
      setSuccess('Opção Alterada')
      setRefresh((v) => !v)
    }
    close()
  }

  return (
    <>
      <ModalOpcoes
        data={perguntaSelecionada}
        openModalDadosCadastrais={openModalDadosCadastrais}
        setRefresh={setRefresh}
        setOpenModalDadosCadastrais={setOpenModalDadosCadastrais}
      />
      <form onSubmit={handleSubmit(salva)}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <TextField
              {...register('dsNome')}
              label="Nome"
              fullWidth
              margin="dense"
              variant="outlined"
              error={!!errors.dsNome}
              helperText={errors.dsNome?.message}
            />
          </Grid>
          <Controller
            name="dsIntroducao"
            control={control}
            render={({ field }) => (
              <TextField
                {...field}
                label="Texto Introdutório"
                fullWidth
                multiline
                minRows={3}
                maxRows={10}
                margin="dense"
                variant="outlined"
                error={!!errors.dsIntroducao}
                helperText={errors.dsIntroducao?.message}
              />
            )}
          />

          {dados?.[0] && (
            <Grid item xs={12}>
              <PrimeTable
                codigo="CtrlQuestionario"
                action="listaPerguntas"
                rows={10}
                habSearch
                parametros={{ idQuestionario: dados?.[0] }}
                head={[
                  '#',
                  'Pergunta',
                  'Tipo',
                  'Obrigatório',
                  'Justificativa',
                  'Inclusão',
                  'Exclusão',
                ]}
                line={(item) => [
                  item[1],
                  item[2],
                  item?.[3] ? <StatusChip status={item[3]} /> : '',
                  item[7] === 'S' ? 'Sim' : 'Não',
                  item[8] === 'S' ? 'Sim' : 'Não',
                  item[4],
                  item[5],
                ]}
                colStyle={[
                  { width: '2%' },
                  { width: '55%' },
                  { width: '15%' },
                  { width: '10%' },
                  { width: '10%' },
                  { width: '10%' },
                  { width: '10%' },
                ]}
                onRowSelect={handleClick}
                collumnsDateHour={[5, 6]}
                onDelete={{ index: 6, action: exclui }}
                refresh={refresh}
                editButton={true}
                addButton={true}
                fastAddComponent={({ values, edit, close }) => (
                  <Grid container spacing={2}>
                    <Grid item md={12}>
                      <TextFieldMt
                        InputLabelProps={{ shrink: true }}
                        name="dsPergunta"
                        label="Pergunta"
                        fullWidth
                        margin="dense"
                        variant="outlined"
                        size="small"
                        value={values?.dsPergunta}
                        onChange={(e) =>
                          edit({
                            value: e.target.value,
                            field: 'dsPergunta',
                          })
                        }
                        helperText={
                          !values?.dsPergunta ? 'Campo Obrigatório!' : ''
                        }
                        error={!values?.dsPergunta}
                      />
                    </Grid>
                    <Grid item md={12}>
                      <TextFieldMt
                        InputLabelProps={{ shrink: true }}
                        name="tpPergunta"
                        label="Tipo de Resposta"
                        fullWidth
                        margin="dense"
                        variant="outlined"
                        size="small"
                        select
                        value={values?.tpPergunta}
                        onChange={(e) =>
                          edit({
                            value: e.target.value,
                            field: 'tpPergunta',
                          })
                        }
                        helperText={
                          !values?.tpPergunta ? 'Campo Obrigatório!' : ''
                        }
                        error={!values?.tpPergunta}
                      >
                        <MenuItem value="L">Texto Livre</MenuItem>
                        <MenuItem value="U">Seleção Única</MenuItem>
                        <MenuItem value="M">Seleção Múltipla</MenuItem>
                        <MenuItem value="T">Coluna Texto Livre</MenuItem>
                        <MenuItem value="C">Coluna Múltipla</MenuItem>
                        <MenuItem value="O">Coluna Seleção Única</MenuItem>
                        <MenuItem value="I">Marcação na Imagem</MenuItem>
                      </TextFieldMt>
                    </Grid>
                    <Grid item md={6}>
                      <TextFieldMt
                        InputLabelProps={{ shrink: true }}
                        name="snObrigaResposta"
                        label="Resposta Obrigatória"
                        fullWidth
                        margin="dense"
                        variant="outlined"
                        size="small"
                        select
                        value={values?.snObrigaResposta}
                        onChange={(e) =>
                          edit({
                            value: e.target.value,
                            field: 'snObrigaResposta',
                          })
                        }
                        helperText={
                          !values?.snObrigaResposta ? 'Campo Obrigatório!' : ''
                        }
                        error={!values?.snObrigaResposta}
                      >
                        <MenuItem value="S">Sim</MenuItem>
                        <MenuItem value="N">Não</MenuItem>
                      </TextFieldMt>
                    </Grid>
                    <Grid item md={6}>
                      <TextFieldMt
                        InputLabelProps={{ shrink: true }}
                        name="snHabilitaJustificativa"
                        label="Habilita Justificativa"
                        fullWidth
                        margin="dense"
                        variant="outlined"
                        size="small"
                        select
                        value={values?.snHabilitaJustificativa}
                        onChange={(e) =>
                          edit({
                            value: e.target.value,
                            field: 'snHabilitaJustificativa',
                          })
                        }
                        helperText={
                          !values?.snHabilitaJustificativa
                            ? 'Campo Obrigatório!'
                            : ''
                        }
                        error={!values?.snHabilitaJustificativa}
                      >
                        <MenuItem value="S">Sim</MenuItem>
                        <MenuItem value="N">Não</MenuItem>
                      </TextFieldMt>
                    </Grid>
                    <Grid
                      item
                      container
                      md={12}
                      spacing={2}
                      justifyContent="flex-end"
                    >
                      <Grid item md={6}>
                        <Button
                          onClick={close}
                          fullWidth
                          variant="contained"
                          color="inherit"
                          style={{ margin: '5px' }}
                        >
                          Cancelar
                        </Button>
                      </Grid>
                      <Grid item md={6}>
                        <Button
                          onClick={() =>
                            !!values?.dsPergunta &&
                            !!values?.tpPergunta &&
                            !!values?.snObrigaResposta &&
                            !!values?.snHabilitaJustificativa &&
                            salvaPergunta(values) &&
                            close()
                          }
                          variant="contained"
                          fullWidth
                          color="primary"
                          style={{ margin: '5px' }}
                        >
                          Salvar
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
                fastEditComponent={({ linha, close, edit }) => (
                  <Grid container spacing={2}>
                    <Grid item md={12}>
                      <TextFieldMt
                        InputLabelProps={{ shrink: true }}
                        name="dsPergunta"
                        label="Pergunta"
                        fullWidth
                        margin="dense"
                        variant="outlined"
                        size="small"
                        value={linha[2]}
                        onChange={(v) =>
                          edit({ value: v.target.value, index: 2 })
                        }
                        helperText={!linha?.[2] ? 'Campo Obrigatório!' : ''}
                        error={!linha?.[2]}
                      />
                    </Grid>
                    <Grid item md={12}>
                      <TextFieldMt
                        InputLabelProps={{ shrink: true }}
                        name="tpPergunta"
                        label="Tipo de Resposta"
                        fullWidth
                        margin="dense"
                        variant="outlined"
                        size="small"
                        select
                        value={linha[3]}
                        onChange={(v) =>
                          edit({ value: v.target.value, index: 3 })
                        }
                        helperText={!linha?.[3] ? 'Campo Obrigatório!' : ''}
                        error={!linha?.[3]}
                      >
                        <MenuItem value="L">Texto Livre</MenuItem>
                        <MenuItem value="U">Seleção Única</MenuItem>
                        <MenuItem value="M">Seleção Múltipla</MenuItem>
                        <MenuItem value="T">Coluna Texto Livre</MenuItem>
                        <MenuItem value="C">Coluna Múltipla</MenuItem>
                        <MenuItem value="O">Coluna Seleção Única</MenuItem>
                        <MenuItem value="I">Marcação na Imagem</MenuItem>
                      </TextFieldMt>
                    </Grid>
                    {linha[3] === 'I' && (
                      <Grid item md={12}>
                        <FileUploader
                          path="/proposta/"
                          snPublico="S"
                          onUploadComplete={(v) => salvaDocumento(linha, v)}
                        />
                      </Grid>
                    )}
                    <Grid item md={6}>
                      <TextFieldMt
                        InputLabelProps={{ shrink: true }}
                        name="snObrigaResposta"
                        label="Resposta Obrigatória"
                        fullWidth
                        margin="dense"
                        variant="outlined"
                        size="small"
                        select
                        value={linha[7]}
                        onChange={(v) =>
                          edit({ value: v.target.value, index: 7 })
                        }
                        helperText={!linha?.[7] ? 'Campo Obrigatório!' : ''}
                        error={!linha?.[7]}
                      >
                        <MenuItem value="S">Sim</MenuItem>
                        <MenuItem value="N">Não</MenuItem>
                      </TextFieldMt>
                    </Grid>
                    <Grid item md={6}>
                      <TextFieldMt
                        InputLabelProps={{ shrink: true }}
                        name="snHabilitaJustificativa"
                        label="Habilita Justificativa"
                        fullWidth
                        margin="dense"
                        variant="outlined"
                        size="small"
                        select
                        value={linha[8]}
                        onChange={(v) =>
                          edit({ value: v.target.value, index: 8 })
                        }
                        helperText={!linha?.[8] ? 'Campo Obrigatório!' : ''}
                        error={!linha?.[8]}
                      >
                        <MenuItem value="S">Sim</MenuItem>
                        <MenuItem value="N">Não</MenuItem>
                      </TextFieldMt>
                    </Grid>

                    <Grid
                      item
                      container
                      xs={12}
                      spacing={2}
                      justifyContent="flex-end"
                    >
                      <Grid item xs={12} md={2}>
                        <Button
                          onClick={close}
                          fullWidth
                          variant="contained"
                          color="inherit"
                          style={{ margin: '5px' }}
                        >
                          Cancelar
                        </Button>
                      </Grid>
                      <Grid item xs={12} md={2}>
                        <Button
                          onClick={() =>
                            !!linha?.[4] &&
                            !!linha?.[3] &&
                            !!linha?.[7] &&
                            !!linha?.[8] &&
                            editarPergunta(linha, close) &&
                            close()
                          }
                          variant="contained"
                          fullWidth
                          color="primary"
                          style={{ margin: '5px' }}
                        >
                          Editar
                        </Button>
                      </Grid>
                    </Grid>
                  </Grid>
                )}
              />
            </Grid>
          )}

          <Grid
            item
            xs={12}
            style={{ display: 'flex', flexDirection: 'row-reverse' }}
          >
            <Button
              type="submit"
              variant="contained"
              color="primary"
              style={{ margin: '5px' }}
            >
              Salvar
            </Button>
            <Button
              onClick={voltar}
              variant="contained"
              color="secondary"
              style={{ margin: '5px' }}
            >
              Cancelar
            </Button>
          </Grid>
        </Grid>
      </form>
    </>
  )
}

export default memo(Edicao, isEqual)
